var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "text-wings" }, [
    _c("span", {
      staticClass: "left-wing",
      style: { width: _vm.wingWidth, height: _vm.height + "px" }
    }),
    _vm._v(" "),
    _c("span", {
      staticClass: "right-wing",
      style: { width: _vm.wingWidth, height: _vm.height + "px" }
    }),
    _vm._v(" "),
    _c(
      "div",
      { ref: "text", staticClass: "text" },
      [_vm._t("default", [_vm._v("PUT YOUR TITLE HERE")])],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }